const logo = `data:image/svg+xml,${encodeURIComponent('<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 120 120"><rect width="120" height="120" rx="20" fill="#4338ca"/><path d="M35 42h50v42H35z" fill="white" opacity=".96"/><path d="M42 50h36M42 60h36M42 70h20" stroke="#4338ca" stroke-width="5" stroke-linecap="round"/></svg>')}`;

const legacyDefaults = {
  name: 'Shopwala',
  fullName: 'Shopwala',
  dealer: '',
  address: 'Modern More, Rangpur, Bangladesh',
  mobile: 'Mobile: 01310751276',
  img: logo,
};

// Existing invoices and reports import this mutable compatibility object directly.
// Updating it from the authenticated tenant session preserves every legacy print template.
const BusinessInfo = { ...legacyDefaults };

export function setTenantBusinessInfo(settings = {}) {
  Object.assign(BusinessInfo, {
    ...legacyDefaults,
    name: settings.businessName || legacyDefaults.name,
    fullName: settings.businessName || legacyDefaults.fullName,
    address: settings.address || legacyDefaults.address,
    mobile: settings.phone ? `Mobile: ${settings.phone}` : legacyDefaults.mobile,
    img: settings.logoUrl || legacyDefaults.img,
  });
}

export default BusinessInfo;
